/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_SameInputs */

const en_us2_profile_row_same = /** @type {(inputs: Profile_Row_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are these always the same days?`)
};

const pt_br2_profile_row_same = /** @type {(inputs: Profile_Row_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esses dias são sempre os mesmos?`)
};

const es_419_profile_row_same = /** @type {(inputs: Profile_Row_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Son siempre los mismos días?`)
};

const pt_pt2_profile_row_same = /** @type {(inputs: Profile_Row_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estes dias são sempre os mesmos?`)
};

const fr_fr2_profile_row_same = /** @type {(inputs: Profile_Row_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce sont toujours les mêmes jours ?`)
};

const de_de2_profile_row_same = /** @type {(inputs: Profile_Row_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind es immer dieselben Tage?`)
};

const it_it2_profile_row_same = /** @type {(inputs: Profile_Row_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono sempre gli stessi giorni?`)
};

/**
* | output |
* | --- |
* | "Are these always the same days?" |
*
* @param {Profile_Row_SameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_same = /** @type {((inputs?: Profile_Row_SameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_SameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_same(inputs)
	if (locale === "es-419") return es_419_profile_row_same(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_same(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_same(inputs)
	if (locale === "de-DE") return de_de2_profile_row_same(inputs)
	if (locale === "it-IT") return it_it2_profile_row_same(inputs)
	return en_us2_profile_row_same(inputs)
});
export { profile_row_same as "profile.row_same" }